<template>
  <div>
    <div class="color"></div>
    <div id="backgroundImage" ref="bgImage">
      <main>
        <v-form ref="form">
          <v-card :class="$vuetify.breakpoint.smAndDown ? 'MobileGroup' : 'DesktopGroup'">
            <div class="logo">
              <logo />
            </div>
            <div>
              <v-alert class="alert" text :value="alert.show" :icon="alert.icon" type="error">{{
                alert.errors.join(", ")
              }}</v-alert>
            </div>
            <div class="form">
              <div :class="['account', hasAzure ? 'account1' : 'account2']">
                <v-text-field
                  id="username"
                  v-model="username"
                  :rules="[rules.required]"
                  @keyup.enter="login"
                  style="font-size: 12px"
                  color="#6684ff"
                  label="Usuário"
                  autocomplete="username"
                  placeholder="Usuário"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  id="password"
                  v-model="password"
                  :rules="[rules.required, rules.min]"
                  @keyup.enter="login"
                  :type="show1 ? 'text' : 'password'"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  @click:append="show1 = !show1"
                  color="#6684ff"
                  label="Senha"
                  placeholder="•••••"
                  autocomplete="current-password"
                  outlined
                  dense
                ></v-text-field>
                <vue-recaptcha
                  ref="recaptcha"
                  @verify="onCaptchaVerified"
                  @expired="onCaptchaExpired"
                  :sitekey="siteKey"
                  class="recaptcha"
                  loadRecaptchaScript
                />
                <v-btn
                  :disabled="loading || !isButtonEnabled"
                  id="automaLogin"
                  class="white--text"
                  small
                  color="#6684ff"
                  depressed
                  :loading="loading"
                  @click="login"
                  >Acessar minha conta</v-btn
                >
              </div>
            </div>
          </v-card>
          <div class="logo-automa">
            <img :src="require(`@/../public/automa/logo-white.png`)" />
          </div>
        </v-form>
      </main>
    </div>
  </div>
</template>

<script>
async function backgroundLogin(vm, username, password, recaptchaToken) {
  try {
    const res = await login({ username, password, recaptchaToken });
    if (res.data === 200) {
      vm.$router.push({ name: "home", query: { redirect: "home" } });
    }
  } catch (e) {
    if (e.message === "Erro de Rede") {
      console.log("Sem conexão com a API de autenticação");
    }
  }
}
function signInMSAL(vm, username, password, recaptchaToken) {
  myMSALObj
    .loginPopup(loginRequest)
    .then(async (loginResponse) => {
      let AppId = loginResponse.idTokenClaims.aud;
      let localAppId = msalConfig.auth.clientId;

      if (AppId == localAppId) {
        backgroundLogin(vm, username, password, recaptchaToken);
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

import logo from "./Logo.vue";
import VueRecaptcha from "vue-recaptcha";
import { mapGetters } from "vuex";
import { login, loginDataAPI, getCurrentUser } from "@/models/User";

export default {
  name: "login",
  components: {
    logo,
    VueRecaptcha,
  },
  data() {
    return {
      show1: false,
      username: "",
      password: "",
      recaptchaToken: "",
      alert: {
        icon: "error",
        errors: [],
        show: false,
      },
      loading: false,
      options: ["Padrão", "Azure"],
      hasAzure: false,
      loginType: "Azure",
      rules: {
        required: (v) => !!v || "Preencha este campo",
        min: (v) => v.length >= 8 || "Min. 8 caracteres",
      },
    };
  },
  computed: {
    ...mapGetters(["getLoggedin"]),
    siteKey() {
      return process.env.VUE_APP_RECAPTCHA_SITE_KEY;
    },
    isButtonEnabled() {
      if (this.username && this.password && this.recaptchaToken) return true;
      return false;
    },
  },
  created() {
    this.hasAzure = !!process.env.VUE_APP_AZURE_USER && !!process.env.VUE_APP_AZURE_CLIENTID;
    let info = localStorage.getItem("autoLoginInfo");
    if (info) {
      info = JSON.parse(info);
      this.autoLogin(info);
    }
  },
  mounted() {
    this.checkAzureLogin();
    if (this.getLoggedin) {
      this.$router.push({ name: "home", query: { redirect: "home" } });
    }
    this.generateBackground();
  },
  methods: {
    async onCaptchaVerified(recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
    generateBackground() {
      try {
        let dinacmicPath = require(`@/../public/${process.env.VUE_APP_PUBLIC_ASSETS}/backgroundLogin.jpg`);
        let bGround = this.$refs.bgImage;
        bGround.style.backgroundImage = `url(${dinacmicPath})`;
      } catch (e) {}
    },
    checkAzureLogin() {
      let msalToken = undefined;
      try {
        msalToken = window.sessionStorage.getItem(
          "msal." + process.env.VUE_APP_AZURE_CLIENTID + ".idtoken"
        );
        if (msalToken) {
          backgroundLogin(this, process.env.VUE_APP_AZURE_USER, process.env.VUE_APP_AZURE_PASSWORD);
        }
      } catch (error) {}
    },
    async login() {
      this.errors = [];
      this.loading = true;
      this.alert.show = false;
      try {
        if (this.$refs.form.validate()) {
          if (!this.recaptchaToken) throw new Error("Não pudemos verificar se você é humano.");

          let res = await login({
            username: this.username,
            password: this.password,
            recaptchaToken: this.recaptchaToken,
          });
          if (res.status === 200) {
            await loginDataAPI({
              username: process.env.VUE_APP_DATA_USER,
              password: process.env.VUE_APP_DATA_PASSWORD,
            });
            await getCurrentUser();
            this.$router.push("home");
          }
        }
      } catch (error) {
        console.error(error);
        /**
         * TODO:
         *  - Evaluate better options to wrap error
         *  - Remove user enumaration
         */

        if (error.response) {
          if (error.response.status >= 500) {
            this.alert.errors = ["Could not connect to API"];
            this.alert.icon = "cloud_off";
          } else {
            let { data } = error.response;
            this.alert.errors = data.non_field_errors;
          }
        } else {
          this.alert.errors = [error];
          this.alert.icon = "cloud_off";
        }
        this.alert.errors = this.alert.errors ? this.alert.errors : ["Invalid credentials"];
        this.alert.show = true;
      }
      this.loading = false;
    },
    async autoLogin({ username, password, page, recaptchaToken }) {
      try {
        const res = await login({ username, password, recaptchaToken });
        this.$router.push({ name: page });
      } catch (error) {
        console.error(error);
      }
    },
    signInAzure() {
      signInMSAL(this, process.env.VUE_APP_AZURE_USER, process.env.VUE_APP_AZURE_PASSWORD);
    },
    signOut() {
      myMSALObj.logout();
    },
  },
};
</script>

<style scoped>
.recaptcha {
  max-width: 304px;
  margin: auto;
}
.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  min-height: 23px;
}
.DesktopGroup {
  min-width: 450px;
  max-width: 550px;
}

.DesktopGroup .account .v-btn {
  height: 40px;
}
.MobileGroup {
  max-width: 320px;
}
.MobileGroup .account .v-btn {
  height: 35px;
}
.color {
  background-image: linear-gradient(to bottom left, rgba(0, 81, 255, 0), #6a88fd 88%);
  width: 100%;
  height: 100%;
  position: absolute;
}
#backgroundImage {
  /* background-image: url("../../../../public/omega/backgroundLogin.jpg");  */
  background-position: center;
  width: 100%;
  height: 100%;
  background-size: cover;
  align-items: center;
}
main {
  min-height: 100vh;
}
main,
.form,
.create,
.alert {
  display: flex;
  align-items: center;
  justify-content: center;
}
.create {
  padding-bottom: 20px;
}
.create .v-btn {
  width: inherit;
  padding: 4px 30px;
}

.login-divider {
  display: flex;
  align-items: center;
}
.login-divider > span {
  margin: 0 5px;
}
.account {
  width: 100%;
  font-size: 12px !important;
  display: grid;
  row-gap: 20px;
  grid-template-rows: 55px 45px auto 5px auto;
  margin: 0 50px 30px 50px;
}
.account1 {
  grid-template-rows: 55px 45px auto 5px auto;
}
.account2 {
  grid-template-rows: 55px 45px auto;
}
.v-btn {
  text-transform: none !important;
  width: 100%;
}
.logo-automa {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
  position: relative;
  z-index: 1;
}
.logo {
  max-width: 430px;
  align-items: center;
  justify-content: center;
}
img {
  height: 22px;
  width: 115px;
}
</style>
